import { Phone, MessageCircle, Instagram, MapPin } from "lucide-react";
import { PageHero, usePageMeta } from "@/components/site/PageHero";
import { CtaBand } from "@/components/site/CtaBand";
import { PHONE_DISPLAY, PHONE_TEL, WA_DEFAULT, INSTAGRAM_URL, ADDRESS, MAP_URL, MAP_EMBED } from "@/lib/site";

const MAPS = MAP_URL;
const CARDS = [
  { icon: MessageCircle, k: "WhatsApp", v: PHONE_DISPLAY, href: WA_DEFAULT, ext: true, id: "whatsapp" },
  { icon: Phone, k: "Telefon", v: PHONE_DISPLAY, href: PHONE_TEL, id: "phone" },
  { icon: Instagram, k: "Instagram", v: "@fxmotorsporlari", href: INSTAGRAM_URL, ext: true, id: "instagram" },
  { icon: MapPin, k: "Adres", v: ADDRESS, href: MAPS, ext: true, id: "map", small: true },
];

export default function Contact() {
  usePageMeta("İletişim", "FX Motor Sporları iletişim: WhatsApp ve telefon 0539 260 83 20. Adres: Ömerli, Mostar Sokak No:10/1, 34799 Çekmeköy/İstanbul.");
  return (
    <>
      <PageHero eyebrow="İletişim" title="Bize ulaş." intro="Soru, bilgi ya da rezervasyon için WhatsApp'tan yaz veya ara." img="/ig/ig15.jpg" alt="FX garajı" crumbs={[{ label: "İletişim" }]} />
      <section className="mx-auto max-w-7xl px-5 py-20 md:px-8">
        <div className="grid grid-cols-1 border-l border-t border-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((c) => (
            <a key={c.id} href={c.href} {...(c.ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} data-testid={`contact-card-${c.id}`} className="group border-b border-r border-white/10 p-8 transition-colors hover:bg-brand">
              <c.icon className="h-8 w-8 text-brand transition-colors group-hover:text-white" strokeWidth={1.5} />
              <p className="mt-8 text-xs uppercase tracking-[0.2em] text-neutral-500 group-hover:text-white/80">{c.k}</p>
              <p className={`mt-1 text-white ${c.small ? "text-base font-semibold leading-snug" : "font-display text-3xl tracking-wide"}`}>{c.v}</p>
            </a>
          ))}
        </div>
        <div className="mt-10 aspect-[16/9] w-full overflow-hidden border border-white/10 md:aspect-[21/9]">
          <iframe title="FX Motor Sporları konum — Çekmeköy / Ömerli" data-testid="contact-page-map" src={MAP_EMBED} className="h-full w-full grayscale invert-[0.9]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </div>
      </section>
      <CtaBand />
    </>
  );
}
